import { useState } from "react";
import { Button } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { useServerApi } from "../hooks/userServerApi";
import {
  applyMcaInterceptToForm,
  showMcaSubmittedNotification,
} from "./mca/mcaApprovalLabels";

const isOpsRole = (role) => {
  const name = String(role || "").toUpperCase();
  return name === "OPS" || name.includes("OPERATION");
};

const ClientProfileClosureButton = ({ mainForm, role }) => {
  const [api] = useServerApi();
  const [loading, setLoading] = useState(false);
  const values = mainForm?.values ?? {};
  const visible =
    isOpsRole(role) &&
    values.disposalStatus === "ELIGIBLE" &&
    !values.mcaRequestId;

  if (!visible) return null;

  const submit = async () => {
    const id = values._id;
    if (!id) return;
    try {
      setLoading(true);
      const result = await api.Client.requestProfileClosure(id);
      if (!result?.success) {
        showNotification({
          color: "red",
          title: "Profile closure",
          message: result?.error || result?.message || "Could not submit",
        });
        return;
      }
      showMcaSubmittedNotification(result);
      applyMcaInterceptToForm(mainForm, result);
    } catch (error) {
      showNotification({
        color: "red",
        title: "Profile closure",
        message: error?.message || "Could not submit",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button color="red" variant="outline" loading={loading} onClick={submit}>
      Request profile closure
    </Button>
  );
};

export default ClientProfileClosureButton;
